/* eslint-disable react-hooks/exhaustive-deps */
import { FunctionComponent, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import SnackBar from 'shared/components/SnackBar'
import { colors } from 'shared/styles/colors'
import { Grid } from '@material-ui/core'
import Center from 'shared/components/Center'
import {
  IFiltroViagens,
  IFindViagensComVPO,
} from 'modules/valePedagio/domain/usecases/FindViagensComVPO'
import {
  BreadCrumb,
  ContainerCards,
  ContainerCenter,
  Content,
  Title,
} from './styles'
import { formatBreadCrumb } from 'shared/components/BasePage/formatBreadCrumb'
import IViagemPedagioDTO from 'modules/valePedagio/domain/entities/IViagemPedagioDTO'
import ViagemCard from '../components/ViagemCard'
import FiltrosViagens from '../components/FiltrosViagens'

type TProp = {
  findViagensComVPO: IFindViagensComVPO
}

const ListViagens: FunctionComponent<TProp> = ({ findViagensComVPO }) => {
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [viagens, setViagens] = useState<IViagemPedagioDTO[]>([])
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [documento, setDocumento] = useState('')
  const [filtro, setFiltro] = useState<IFiltroViagens>({ placa: '', cte: '' })

  const getViagens = async () => {
    setLoading(true)
    try {
      const params = history.location.state as {
        documento?: string
      }
      const response = await findViagensComVPO.execute(
        params?.documento,
        filtro,
      )

      setDocumento(params?.documento ?? '')
      setViagens(response)
      setLoading(false)
    } catch (error) {
      setError(true)
      if (error instanceof Error) {
        setErrorMessage(error.message)
      } else {
        setErrorMessage('Erro buscar motoristas')
      }
      setLoading(false)
    }
  }

  useEffect(() => {
    getViagens()
  }, [])

  return (
    <>
      <Content>
        <BreadCrumb>
          <Title>{formatBreadCrumb('Vale Pedágio / Lista de viagens')}</Title>
        </BreadCrumb>
        {loading ? (
          <LoadingBackdrop open={loading} color={colors.green} />
        ) : error ? (
          <ContainerCenter>
            Não foi possível carregar as viagens, por favor tente novamente em
            alguns minutos.
          </ContainerCenter>
        ) : (
          <ContainerCards>
            <FiltrosViagens
              getViagens={getViagens}
              setFiltro={setFiltro}
              filtro={filtro}
            />
            {viagens?.length > 0 ? (
              <Grid container spacing={2}>
                {viagens.map((value, idx) => (
                  <Grid key={value.id} item xs={12} sm={6} md={4} lg={4} xl={3}>
                    <ViagemCard
                      viagem={value}
                      onClick={() => {
                        history.push('/vale-pedagio/detalhes', {
                          params: {
                            id: value.id,
                            documento: documento,
                          },
                        })
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Center>Não há viagens cadastradas para esse motorista.</Center>
            )}
          </ContainerCards>
        )}
      </Content>
      <SnackBar
        open={error}
        setOpen={setError}
        severity="error"
        message={errorMessage}
        horizontal="right"
      />
    </>
  )
}

export default ListViagens
